<template>
    <div class="af">
        <el-form  :model="formData" ref="formRef" label-width="90px" size="mini">
                <div class="flex" >
                    <el-form-item class="form-title" prop="apply_ent_id" label="申购单位" required>
                        <div style="min-width: 200px" v-if="!canEdit" class="mrA">{{formData.apply_ent_name}}</div>
                        <el-select style="width: 200px"  size="mini" @change="select('dw')" v-model="formData.apply_ent_id" placeholder="请选择申购单位" filterable required v-else>
                            <el-option

                                    v-for="item in companyName"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
<!--                                <span  style="display: inline-block;width: 100%">{{item.vc_name}}</span>-->
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="depart_id" label="申购部门" required>
                        <div style="min-width: 200px" v-if="!canEdit" class="mrA">{{formData.depart_name}}</div>
                        <el-select style="width: 200px" size="mini" @change="select('bm')" v-model="formData.depart_id" :placeholder="$t('form_please_select_department')"  filterable required v-else>
                            <el-option
                                    v-for="itembm in groupName"
                                    :key="itembm.i_id"
                                    :label="itembm.vc_name"
                                    :value="itembm.i_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="applicant_name" label="申购人" required>
                        <span style="width: 200px;display: inline-block">{{formData.applicant_name}}</span>
                    </el-form-item>
                    <el-form-item class="form-title" prop="attr_id" label="产品属性" required>
                        <div style="width: 200px" v-if="!canEdit" class="mrA">{{formData.attr_name}}</div>
                        <el-select style="width: 200px" @change="select('pzsx')" size="mini" v-model="formData.attr_id" placeholder="产品属性"  filterable required v-else>
                            <el-option
                                    v-for="itemsq in pzsxListData"
                                    :key="itemsq.vc_flags"
                                    :label="itemsq.vc_name"
                                    :value="itemsq.vc_flags">
                            </el-option>
                        </el-select>
                    </el-form-item>
<!--                    <el-form-item class="form-title" prop="ckname" label="申请日期" required>-->
<!--                        <el-date-picker-->
<!--                                v-else-->
<!--                                value-format="yyyy-MM-dd"-->
<!--                                format="yyyy-MM-dd"-->
<!--                                size="mini"-->
<!--                                class="input"-->
<!--                                v-model="sqDate"-->
<!--                                type="date"-->
<!--                                placeholder="申请日期"-->
<!--                        >-->
<!--                        </el-date-picker>-->
<!--                    </el-form-item>-->
                    <el-form-item class="form-title" prop="deliver_date" label="到货日期" required>
                        <div style="width: 200px" v-if="!canEdit" class="mrA">{{formData.deliver_date}}</div>
                        <el-date-picker
                                v-else
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                size="mini"
                                class="input"
                                v-model="formData.deliver_date"
                                type="date"
                                style="width: 200px"
                                placeholder="到货日期"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="form-title" prop="end_date" label="截止日期" required>
                        <div style="width: 200px" v-if="!canEdit" class="mrA">{{formData.end_date}}</div>
                        <el-date-picker
                                style="width: 200px"
                                v-else
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                size="mini"
                                class="input"
                                v-model="formData.end_date"
                                type="date"
                                placeholder="截止日期"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item  prop="title" label="标题" required>
                        <div style="width: 200px" v-if="!canEdit" class="mrA">{{formData.title}}</div>
                        <el-input
                                style="min-width: 200px"
                                v-else
                                size="mini"
                                class="input"
                                placeholder="输入标题"
                                v-model="formData.title"
                                clearable
                                @paste.native="handlePaste($event,'title')">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="purpose" label="用途" required>
                        <div style="min-width: 200px" v-if="!canEdit" class="mrA">{{formData.purpose}}</div>
                        <el-input
                                style="width: 200px"
                                v-else
                                size="mini"
                                class="input"
                                placeholder="输入用途"
                                v-model="formData.purpose"
                                clearable
                                @paste.native="handlePaste($event,'purpose')">
                        </el-input>
                    </el-form-item>
                </div>
            <el-form-item  prop="remarks" :label="$t('form_notes')" >
                <div  v-if="!canEdit" class="mrA">{{formData.remarks}}</div>
                <el-input
                        v-else
                        size="mini"
                        class="input"
                        placeholder="输入备注"
                        v-model="formData.remarks"
                        clearable
                        @paste.native="handlePaste($event,'remarks')">
                </el-input>
            </el-form-item>
            <div style="margin-bottom: 10px">
                <el-table class="table"
                        border
                        ref="multipleTable"
                        :data="formData.sub"
                        :height="tableHeight"
                        size="mini"
                        tooltip-effect="dark"
                        >
                    <el-table-column :label="$t('form_serial_number')" align="left" type="index" width="55"> </el-table-column>
                    <el-table-column  width="200" align="left" prop="name" label="产品名称"  show-overflow-tooltip> </el-table-column>
                    <el-table-column width="100" align="left" prop="model" label="规格" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="quantity"　label="数量"　width="120px"show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-input-number  v-if="canEdit" v-model="scope.row.quantity" clearable size="mini" :controls="false" :min="0" ></el-input-number>
                            <span v-else>{{scope.row.quantity}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="unit" label="单位"  width="80" show-overflow-tooltip>
                    </el-table-column>
<!--                    <el-table-column  align="left"  prop="quantity" label="数量"  width="80" show-overflow-tooltip> </el-table-column>-->
                    <el-table-column align="left" prop="buyrequire" label="要求"show-overflow-tooltip >
                        <template  slot-scope="scope" >
                            <el-form-item  class="tableForm-item" :prop="scope.row.buyrequire" v-if="canEdit">
                                <el-input class="changeinput" size="mini" @paste.native="handlePaste($event,'buyrequire',scope.$index)" v-model="scope.row.buyrequire"></el-input>
                            </el-form-item>
                            <span v-else>{{scope.row.buyrequire}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column  width="50" label="操作" align="center">
                        <template slot="header" slot-scope="scope" v-if="canEdit">
                            <el-button  icon="el-icon-plus"  @click="pzDetail"   size="mini" v-if="canEdit" type="text" ></el-button>

<!--                            <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>-->
                        </template>
                        <template slot-scope="scope" v-if="canEdit">
                            <el-button  icon="el-icon-minus" type="text" @click="deletepz(scope.row,scope.$index)"  size="mini" class="mrl10" v-if="state==-1||state==0"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div>
                <span style="font-size: 12px;margin-left: 28px">请上传申购产品说明,规格补充说明等附件.(非必需)</span>
                <el-form-item class="form-title "  label="附件" style="margin-bottom: 5px;margin-left: -12px">
                    <template v-if="(!formData.vc_files||formData.vc_files.otherfiles.length==0)&&canEdit">
                        <el-button  style="position: relative">上传附件<input type="file" name="files" value="" id="uploadfile3"
                                              ref="uploadclear1"    class="upload-input uploadfile1" @change="uploadFile" /></el-button>
                    </template>
                    <template v-if="formData.vc_files&&formData.vc_files.otherfiles.length!=0">
                        <div v-for="(file,index) in formData.vc_files.otherfiles">
                            <a
                                    :download="file.vc_name"
                                    mce_href="#"
                                    :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+file.vc_newname+'\'}','utf-8')">
                                <!--:herf="file"-->     {{file.vc_name}}
                            </a>
                            <el-button @click="clearFile(file,index)" v-if="canEdit">删除附件</el-button>
                        </div>
                    </template>
                    <template v-if="formData.vc_files&&JSON.stringify(formData.vc_files.signfile)!=='{}'">
                            <a
                                    :download="formData.vc_files.signfile.vc_name"
                                    mce_href="#"
                                    :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+formData.vc_files.signfile.vc_newname+'\'}','utf-8')">
                                <!--:herf="file"-->     {{formData.vc_files.signfile.vc_name}}
                            </a>
<!--                            <el-button @click="clearFile(file,index)" v-if="canEdit">删除附件</el-button>-->
                    </template>
                </el-form-item>
            </div>
            <div class="formDiv flex jcsb">
                <el-form-item class="form-title" prop="vc_lruname" :label="$t('form_creator')" >
                    <span>{{formData.vc_lruname}}</span>
                </el-form-item>
                <el-form-item class="form-title" prop="apply_date" label="制单日期" >
                    <span>{{formData.apply_date}}</span>
                </el-form-item>
                <template v-if="formData.status==-2">
                    <el-form-item class="form-title" prop="vc_canceluser" label="作废操作人" v-if="formData.vc_canceluser">
                        <span>{{formData.vc_canceluser}}</span>
                    </el-form-item>
                    <el-form-item class="form-title" prop="dt_canceltime" label="作废时间" v-if="formData.vc_canceluser">
                        <span>{{formData.dt_canceltime}}</span>
                    </el-form-item>
                </template>
                <template v-if="formData.status==-3">
                    <el-form-item class="form-title" prop="vc_canceluser" label="驳回操作人" v-if="formData.vc_canceluser">
                        <span>{{formData.vc_canceluser}}</span>
                    </el-form-item>
                    <el-form-item class="form-title" prop="dt_canceltime" label="驳回时间" v-if="formData.vc_canceluser">
                        <span>{{formData.dt_canceltime}}</span>
                    </el-form-item>
                </template>

            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <template v-if="formData.status==1||formData.status==0||formData.status==-2||formData.status==-3||formData.status==4">
                <el-button type="primary" @click="saveForm" :disabled="flow" :class="baseerp+'btn'" size="small" v-if="canEdit">{{$t('button_save')}}</el-button>
                <el-button type="primary" @click="editForm" :disabled="flow" :class="baseerp+'btn'" size="small" v-if="!canEdit">编辑</el-button>
                <el-button type="warning" @click="flowSub" :disabled="flow" size="small" v-if="!canEdit">提交审批</el-button>
            </template>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
            <el-button type="success" @click="copyForm" :disabled="flow" size="small" v-if="!canEdit">再次申购</el-button>
            <el-button type="danger" @click="zuofei" :disabled="flow" size="small" v-if="formData.transToOfflineAble">{{$t('button_nullify')}}</el-button>

        </div>
        <el-dialog title="选择品种"
                   :class="[baseerp+'div' ,'minw']"
                   width="60%"
                   :visible.sync="dialogPzVisible"
                   :close-on-click-modal="false"
                   :append-to-body="true">
            <pz-list :add="addPz" @close="closePz" v-if="dialogPzVisible"></pz-list>
        </el-dialog>
        <el-dialog title="复制申购单"
                   width="75%"
                   top="1%"
                   :class="[baseerp+'div' ,'minw']"
                   :visible.sync="dialogcopyVisible"
                   :close-on-click-modal="false"
                   @close="closecopyFun" :append-to-body="true">
            <copy-subscribe v-if="dialogcopyVisible" :data="copyData" @close="closecopyFun"></copy-subscribe>
        </el-dialog>
    </div>
</template>
<script>
    import * as API from "../../api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";
    import PzList from "./SubPzList";
    import CopySubscribe from "./CopySubscribe";
    export default {
        components: { PzList,CopySubscribe},
        props:{
            data:{
                type:Object,
                required:true,
            }
        },
        data(){
            return{
                tableHeight:0,
                formData:{
                    apply_ent_id:'',
                    depart_id:'',
                    applicant_name:'',
                    i_flag:'',
                    deliver_date:'',
                    end_date:'',
                    title:'',
                    purpose:'',
                    remarks:"",
                    vc_lruname:"",
                    apply_date:'',
                    vc_files:{otherfiles:[],signfile:{}},
                    sub:[],
                    attr_id:'',
                },
                companyName:[],
                groupName:[],
                pzsxListData:[],
                // tableData:[],
                disabled:false,
                dialogPzVisible:false,
                dialogcopyVisible:false,
                canEdit:true,
                state:0,
                pageSize:1,
                baseerp:"",
                token:'',
                i_uid:'',
                flow:false,
                file_url: '',
                baseApp:"",
                baseVersion:"",
                mid:0,
                addPz:{},
            }
        },
        watch: {
            data: {
                handler() {
                    if (this.data) {
                        this.mid = this.data.i_mid;
                        this.i_id=this.data.i_id;
                        this.i_pid=this.data.i_pid;
                        this.formData={
                            apply_ent_id:'',
                                depart_id:'',
                                applicant_name:'',
                                i_flag:'',
                                deliver_date:'',
                                end_date:'',
                                title:'',
                                purpose:'',
                                remarks:"",
                                vc_lruname:"",
                                apply_date:'',
                                vc_files:{otherfiles:[],signfile:{}},
                            sub:[],
                                attr_id:'',
                        };
                        // console.log(this.i_id,'this.i_id',this.data,'this.data')
                        if(this.i_id==0){
                            this.canEdit=true
                            this.formData.i_id=this.i_id
                            this.formData.status=this.data.status
                            this.formData.vc_lruname=sessionStorage.getItem("lruname")
                            this.formData.applicant_name=sessionStorage.getItem("lruname")
                            this.formData.applicant_id=sessionStorage.getItem("userid")
                            this.getDateYYYYMMddHHMMSS();
                            this.getCompanyList();
                            //this.getGroupList();
                            this.pzsxList()
                        }else{
                            this.detail()
                            this.canEdit=false
                        }
                        // console.log(this.fo,'foemate')
                    }
                },
                immediate: true,
                deep: true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.i_uid= sessionStorage.getItem("userid");
            this.token=sessionStorage.getItem("token");
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods:{
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-145
                if(this.tableHeight<60)this.tableHeight=60
            },
            cancel(){
                this.$emit('close')
            },
            async detail(){
                this.canEdit=false

                let param={
                    i_mid: this.mid,
                    i_id:this.i_pid,
                };
                let res=await API.applybuyDetail(param);
                if ( res.code == 1 ){
                    this.formData=res.data
                    this.i_id=this.formData.i_id
                    this.$forceUpdate()
                    // console.log('ssss',this.formData.status)
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            zuofei(){
                    this.$confirm('是否要作废该申请单','提示',{
                        confirmButtonText:'继续',
                        cancelButtonText:'取消',
                        type:'warning'
                    }).then(()=>{
                        this.cancelzuofei()
                    }).catch(()=>{
                        this.$message({
                            type:'info',
                            message:'已取消删除'
                        })
                    })
            },
            async cancelzuofei(){
                this.flow=true

                let param={
                    i_id:this.i_id,
                    i_type:1,
                };
                let res=await API.cancel(param);
                if ( res.code == 1 ){
                    this.flow=false
                    this.$message.success(res.message)
                    this.$emit('refresh')
                    this.cancel()
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.flow=false
                    this.$message.error(res.message);
                }else{
                    this.flow=false
                    this.$message.error(res.message);
                }
            },
            async getCompanyList(){
                let param={
                    i_mid: this.mid,
                };
                let res=await API.getCompanyList(param);
                if(res.code==1){
                        this.companyName=res.data;
                        if (res.data.length>0){

                            if(this.i_id==0){
                            this.formData.apply_ent_name=this.companyName[0].vc_name;
                            this.formData.apply_ent_id=this.companyName[0].i_id;
                            this.getGroupList();
                        }else{
                            let obj=this.companyName.find(f=>f.i_id==this.formData.apply_ent_id);
                            if(obj)this.formData.apply_ent_name=obj.vc_name
                        }
                        this.$forceUpdate()
                    }

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async pzsxList(){
                let param={
                    // i_mid: this.mid,
                };
                let res=await API.pzsxList(param);
                if(res.code==1){
                    if (res.data.length>0){
                        this.pzsxListData=res.data;

                        // this.$forceUpdate()
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },

            async getGroupList(){
                let param={
                    i_mid: this.mid,
                    i_gsid:this.formData.apply_ent_id,
                };
                let res=await API.getGroupList(param);
                if(res.code==1){
                    this.groupName=res.data;
                    if (res.data.length>0){
                        if(this.i_id==0){
                        this.formData.depart_id=this.groupName[0].i_id
                        this.formData.depart_name=this.groupName[0].vc_name
                    }else{
                        let obj=this.groupName.find(f=>f.i_id==this.formData.depart_id);
                        if(obj)this.formData.depart_name=obj.vc_name
                    }}
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            select(type){
                if(type=='dw') {
                    let obj=this.companyName.find(f=>f.i_id==this.formData.apply_ent_id);
                    this.formData.apply_ent_name=obj.vc_name;
                    this.groupName=[];
                    this.formData.depart_id=0;
                    this.formData.depart_name='';
                    this.getGroupList();
                    this.$forceUpdate()
                }else if(type=='bm') {
                    let obj=this.groupName.find(f=>f.i_id==this.formData.depart_id);
                    this.formData.depart_name=obj.vc_name;
                    this.$forceUpdate()
                }else if(type=='pzsx'){
                    if(this.formData.sub.length>0){
                        this.$confirm('更换产品属性会清空已经选择的产品列表,是否继续','提示',{
                            confirmButtonText:'继续',
                            cancelButtonText:'取消',
                            type:'warning'
                        }).then(()=>{
                            this.formData.sub=[];
                            let obj=this.pzsxListData.find(f=>f.vc_flags==this.formData.attr_id);
                            this.formData.i_flag=obj.i_id
                            this.formData.attr_name=obj.vc_name
                            this.$forceUpdate()
                        }).catch(()=>{
                            this.$message({
                                type:'info',
                                message:'已取消删除'
                            })
                        })
                    }else{
                        let obj=this.pzsxListData.find(f=>f.vc_flags==this.formData.attr_id);
                        this.formData.i_flag=obj.i_id
                        this.formData.attr_name=obj.vc_name
                        this.$forceUpdate()
                    }
                }


            },
            pzDetail(){
                if(this.formData.attr_id){
                    this.dialogPzVisible=true;
                    this.addPz={
                        vc_flags: this.formData.attr_id,
                        sub:this.formData.sub,
                    }
                }else{
                    this.$message.warning('请选择产品属性')
                }

            },
            closePz(pzitem){
                // console.log(pzitem,'pzitemb')

                let arr=[...this.formData.sub,...pzitem];
                let hash = {};
                arr = arr.reduce(function(item, next) {
                    hash[next.name_id] ? '' : hash[next.name_id] = true && item.push(next);
                    return item
                }, []);
                this.formData.sub=arr;
                // console.log( this.formData.sub,'this.formData.sub')
                this.$forceUpdate();
                this.dialogPzVisible=false;
            },
            deletepz(val,index){
                this.formData.sub.splice(index,1)
            },
            clearFile(val,index){
                this.formData.vc_files.otherfiles.splice(index,1)
                // this.formData.vc_files.otherfiles=[]
                this.$forceUpdate()
            },
            async uploadFile(e) {
                let that = this;
                let i = 0;
                let $files = e.target.files[0];
                let fileName = $files.name;
                let type = $files.type;
                var list = {
                    "image/jpeg": true,
                    "image/png": true,
                    "image/jpg": true,
                    "image/bmp": true,
                    "application/pdf": true
                };
                let result = list[type];
                if(($files && result==false) || ($files &&result==undefined)){
                    that.$message.error('请上传格式正确的文件');
                    return;
                };
                if ($files) {
                    that.fileName = $files.name;
                    that.fileType = $files.type;
                    that.fileUrl = window.URL.createObjectURL(e.target.files[0]);
                } else {
                    that.fileName = "";
                    that.fileType = "";
                    that.fileUrl = "";
                }
                if (that.fileName) {
                    var fileId = 'uploadfile' + that.idNum;
                    var param = {
                        // "file": fileId,
                        // "fileName": that.fileName,
                        // "IDtype": "",
                        // "type": 1,
                        "style": "tenderpub",
                        "files": $files,
                        //"token":sessionStorage.getItem("token"),
                        //"app": "dsmanage",
                        "vc_app": "tenderpub",
                        "i_appid": 0,
                        // "version": "1.0",
                        // "i_uid": sessionStorage.getItem("userid"),
                        "vc_lruname":  sessionStorage.getItem("lruname"),
                        "i_lruid": sessionStorage.getItem("userid"),
                        // "i_mid": this.mid
                    };
                    let FD = new FormData();
                    for (let key in param) {
                        FD.append(key, param[key])
                    }
                    let res = await API.uploadFile(param);
                    if (res.code == 1) {
                        // this.filesImgList.push(res.data[0])
                        // this.filesList.push(res.data[0].i_id)
                        let file={
                            i_id:res.data[0].i_id,
                            vc_name:res.data[0].filename,
                            vc_newname:res.data[0].filenewname,
                            vc_path:res.data[0].vc_path
                        }
                        this.formData.vc_files.otherfiles.push(file)
                        this.$forceUpdate()

                        // console.log(this.leaveList[index])
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                }
            },
            editForm(){
                this.canEdit=true
                this.getCompanyList();
                this.getGroupList();
                this.pzsxList()
            },

            copyForm(){
                this.copyData=this.formData
                this.dialogcopyVisible=true
            },
            closecopyFun(type=''){
                this.dialogcopyVisible=false
                if(type=='save')this.$emit('refresh')
            },
            handlePaste(event,name,index) {
                //console.log(event,'event',name,'name');
                const clipboardData = (event.clipboardData || window.clipboardData).getData('text');
                const hasExcelFormat = /[\t\n\r"]/.test(clipboardData);
                if (hasExcelFormat) {
                    event.preventDefault();
                    this.$confirm('检测到粘贴内容包含无效格式（多行多列或带引号）。是否自动将其转换为单行空格分隔并清理双引号？', '格式清理提示', {
                        confirmButtonText: '立即替换',
                        cancelButtonText: '保持原样',
                        type: 'warning'
                    }).then(() => {
                        const cleanedText = this.cleanExcelData(clipboardData);
                        this.insertText(cleanedText,name,index);
                        this.$message.success('已自动清理格式');
                    }).catch(() => {
                        this.insertText(clipboardData,name,index);
                    });
                }
            },
            cleanExcelData(text) {
                return text
                    .replace(/"/g, '')               // 移除所有双引号
                    .replace(/[\t\n\r]+/g, ' ')      // 将连续的制表符、换行符替换为一个空格
                    .trim();                         // 去除首尾空格
            },
            insertText(text,name,index) {
                if(name=='remarks')this.formData.remarks=text;
                if(name=='title')this.formData.title=text;
                if(name=='purpose')this.formData.purpose=text;
                if(name=='buyrequire')this.formData.sub[index].buyrequire=text;
            },
            validateInput(inputValue) {
                //const regex = /[\n\r"]/;
                const regex = /[\t\n\r"]/;
                if (regex.test(inputValue)) {
                    return {
                        isValid: false,
                        message: "检测到标题、用途、备注里包含非法字符（回车或双引号），请检查并清理后再保存。"
                    };
                }
                return { isValid: true };
            },
            //保存
           async saveForm(){
               const result = this.validateInput(this.formData.remarks);
               const result_ti = this.validateInput(this.formData.title);
               const result_pur = this.validateInput(this.formData.purpose);
               if (!result.isValid||!result_ti||!result_pur) {
                   this.$message.error(result.message);
                   return;
               }
               if(this.formData.sub.length==0){
                    this.$message.error('请选择申购产品');
                    return
                }else if(!this.formData.depart_id){
                   this.$message.error('请选择申购部门');
                   return
               }else if(!this.formData.apply_ent_id){
                    this.$message.error('请选择申购单位');
                    return
                }else if(!this.formData.deliver_date){
                    this.$message.error('请选择到货日期')
                    return
                }else if(!this.formData.end_date){
                    this.$message.error('请选择到截止日期')
                    return
                }else if(!this.formData.title){
                    this.$message.error('请输入标题')
                    return
                }else if(!this.formData.purpose){
                    this.$message.error('请输入用途')
                    return
                }else if(this.formData.sub.length!==0){
                    let cans=true,isValid=true;
                    for (let pz of this.formData.sub){
                        if(pz.quantity<=0){
                            cans=false
                            break
                        }
                        if(pz.buyrequire){
                            //const regex = /[\n\r"]/;
                            const regex = /[\t\n\r"]/;
                            if (regex.test(pz.buyrequire)){
                                isValid=false
                                break
                            }
                        }
                    }
                    if (!cans){
                        this.$message.error('请输入申购产品数量')
                        return
                    }
                   if (!isValid){
                       this.$message.error("检测到要求里包含非法字符（回车或双引号），请检查并清理后再保存。");
                       return
                   }
                }
               this.flow=true
                let param=this.formData
                let res=await API.saveApplyBuy(param);
                if(res.code==1){
                    this.flow=false
                    this.$message.success(res.message);
                    this.i_pid=res.data;
                    this.detail()
                    this.$emit('refresh')
                }else if (res.code == -2) {
                    this.flow=false
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.flow=false
                    this.$message.error(res.message);
                }
            },
            async flowSub(item){
                this.flow=true
                this.$message.info('正在提交，请稍候')
                let param={
                    id:this.formData.i_id,

                    i_id:this.formData.i_id,
                    apply_date:this.formData.apply_date,
                    table:this.formData.table,
                    create_id:this.formData.create_id,
                    busType:this.formData.busType,
                    validateCode:this.formData.validateCode,
                    validateKeynames:this.formData.validateKeynames,
                };
                let res=await API.flowSub(param);
                if ( res.code == 1 ){
                    this.flow=false
                    this.$message.success(res.message)
                    this.$emit('refresh')
                    this.cancel()
                }else if (res.code == -2) {
                    this.flow=false

                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.flow=false
                    this.$message.error(res.message);
                }
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                this.formData.apply_date=`${date.getFullYear()}-${month}-${strDate}`;
            },
        }
    }
</script>

<style lang="scss" >
    .af{
        position: relative;
    }
    .plusBtn{
        position: absolute;
        right: 0;
        top: 0px;
        height: fit-content;margin: 10px 0;
    }
    .mrB0{
        margin-bottom: 0;
    }
    .uploadfile1{
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }
    .minw{
        min-width: 550px;
    }
    .flex{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }
    .jcsb{
        justify-content: space-between;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
    }
    .num .el-form-item__label {
            color: #b3d268;
            font-size: 16px;
            font-style: italic;
        }
        .num .el-form-item__content {
            width: 130px;
        }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .tableForm-item{
        margin: 0;
        width: 100%;
        /deep/{
            .el-form-item__content{
                width: 100%;
                margin-left: 0 !important;
            }
        }
    }
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
    }
    .table {
        .el-form-item--mini.el-form-item, .table.el-form-item--small.el-form-item {
            margin-bottom: 0px;
        }
    }
    .el-button i{
        font-size: 18px;
        font-weight: bold;
    }
    .cell .el-button{
        padding: unset;
    }
        /deep/{
            .el-button i{
                font-size: 18px;
                font-weight: bold;
            }
            .cell .el-button{
                padding: unset;
            }
            .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
                color: white;
            }
            .el-dialog{
                min-width: 550px;
            }
            .table {
                 .el-form-item--mini.el-form-item, .table.el-form-item--small.el-form-item {
                     margin-bottom: 0px;
                 }
             }
            .el-input__inner {
                height: 24px;
                line-height: 24px;

            }
            .cell .el-input__inner{
                height: 24px;
                line-height: 24px;
            }
            .el-table .cell{
                height: 24px;
                line-height: 24px;
            }
            .el-input-number--mini {
                width: 96px;
                line-height: 26px;
            }
            .danger-row{
                color: #999;
            }
        }

</style>
